import URLS from './data.json';

export default { ...URLS };
